import classNames from "classnames";
import { Tag } from "antd/lib";
import { useTranslation } from "react-i18next";
import { AlertIcon, IdeasIcon, LifeStoryIcon, NoteIcon, UsersIcon } from "@/shared/icons";
import type { FC } from "react";
import type { NoteStatus, NoteTypes } from "@/services/api/entities/note/types";
import styles from "./styles.module.scss";

type Props = {
  noteType: NoteTypes;
  status: NoteStatus;
};

export const NoteTypeTag: FC<Props> = ({ noteType, status, ...props }) => {
  const { t } = useTranslation();

  const getType = () => {
    switch (noteType) {
      case "DEFAULT_COMMITMENT":
        return {
          color: status === "DONE" ? "default" : "magenta",
          text: t("common.noteType.commitment", { count: 1 }),
          icon: (
            <AlertIcon
              width={12}
              height={12}
              className={classNames({
                [styles["tag-commitment"]]: status !== "DONE",
              })}
            />
          ),
        };
      case "DEFAULT_NOTE":
        return {
          color: "blue",
          text: t("common.noteType.note", { count: 1 }),
          icon: <NoteIcon width={12} height={12} className={styles["tag-note"]} />,
        };
      case "DEFAULT_IDEA":
        return {
          color: status === "DONE" ? "default" : "green",
          text: t("common.noteType.idea", { count: 1 }),
          icon: (
            <IdeasIcon
              width={12}
              height={12}
              className={classNames({
                [styles["tag-idea"]]: status !== "DONE",
              })}
            />
          ),
        };
      case "DEFAULT_LIFE_STORY":
        return {
          color: "volcano",
          text: t("common.noteType.lifeStory", { count: 1 }),
          icon: <LifeStoryIcon width={9} height={12} className={styles["tag-life-story"]} />,
        };
      case "DEFAULT_MEETING":
        return {
          color: "purple",
          text: t("common.noteType.meeting", { count: 1 }),
          icon: <UsersIcon width={13} height={13} className={styles["tag-meeting"]} />,
        };
      default:
        return {
          color: "blue",
          text: t("common.noteType.note", { count: 1 }),
          icon: <NoteIcon width={12} height={12} className={styles["tag-note"]} />,
        };
    }
  };
  const tag = getType();
  return (
    <Tag color={tag.color} className={styles["tag"]} {...props}>
      <div className={styles["tag-content"]}>
        {tag.icon}
        {tag.text}
      </div>
    </Tag>
  );
};
